<script>
    import { preventDefault } from 'svelte/legacy';

import { environment } from "@app/store/envStore.svelte.js";
import {
    projectState
} from '@app/store/projectStore.svelte.js';
import {
    insertHistoryAction
} from '@app/store/historyStore.svelte.js';
import {
    hideModal
} from '@app/store/modalStore.svelte.js';
import {authState} from '@app/store/authStore.svelte.js';
import { can } from "@app/lib/entitlements.js";
import * as m from "@app/paraglide/messages.js";

import workflowDict from '@cclib/dict/workflow.js';

let useLocalStorage = $state(projectState.useLocalStorage);
let projectType = $state(projectState.type);
let name = $state(projectState.name);
let state = $state(projectState.state);
let aspectRatio = $state(projectState.media.aspectRatio);
let description = $state(projectState.description);
let createdOn = new Date(projectState.created).toString();
let projectDefaults = JSON.parse(localStorage.getItem("cc-project-defaults")) || {};
let canCreateLiveProject = $derived(
    environment.online &&
        can("liveCaptions"),
);
let canShowProjectType = $derived(
    (authState.team && authState.team.id) || canCreateLiveProject,
);

function saveChanges() {
    projectState.type = projectType;
    projectState.name = name;
    projectState.description = description;
    projectState.media.aspectRatio = aspectRatio;
    projectState.useLocalStorage = useLocalStorage;
    projectState.state = state;
    localStorage.setItem("cc-project-defaults", JSON.stringify({...projectDefaults, useLocalStorage : useLocalStorage}));

    insertHistoryAction({
        name: "project update", //action name
        eventGroup: projectState.selected,
        snapshots: [{
            store: "projectState",
            value: JSON.stringify(projectState)
        }]
    });

    hideModal();
}
</script>

<form id="generalSettingsForm" onsubmit={preventDefault(saveChanges)} aria-label={m.options_general_form_label()}>
    <div class="mb-3 p-3 rounded bg-dark-subtle">
        <label id="projectStateLabel" class="form-label" for="projectStateSelect">{m.options_general_project_state()}</label>
        <select id="projectStateSelect" class="form-select" bind:value={state}>
            {#each workflowDict.states as state (state)}
                <option>{state}</option>
            {/each}
        </select>
    </div>
    <hr class="bg-secondary mt-4"/>
    {#if canShowProjectType}
    <div class="mb-3">
        <label id="projectTypeLabel" class="form-label" for="projectTypeSelect">{m.options_general_project_type()}</label>
        <select id="projectTypeSelect" class="form-select {projectState.type === "team" ? 'bg-light' : ''}" bind:value={projectType} disabled={projectState.type === "team"}>
            <option value="default">{m.options_general_project_type_default()}</option>
            {#if authState.team && authState.team.id}
                <option value="team">{m.options_general_project_type_team()}</option>
            {/if}
            {#if canCreateLiveProject}
                <option value="live">{m.options_general_project_type_live()}</option>
            {/if}
        </select>
    </div>
    {/if}
    {#if environment.online}
    <div class="row mb-3">
        <div class="col-6">
            <div class="form-check form-switch">
                <input id="useLocalStorageCheck" type="checkbox" class="form-check-input" bind:checked={useLocalStorage} aria-labelledby="useLocalStorageLabel">
                <label class="form-check-label" id="useLocalStorageLabel" for="useLocalStorageCheck">{m.options_general_use_local_storage()} <i class="bi bi-info-circle" title={m.options_general_use_local_storage_help()}></i></label>
            </div>
        </div>
    </div>
    {/if}

    <div class="mb-3">
        <label id="projectNameLabel" class="form-label" for="projectNameInput">{m.options_general_project_name()}</label>
        <input id="projectNameInput" class="form-control" type="text" bind:value={name} aria-labelledby="projectNameLabel">
    </div>
    <div class="mb-3">
        <label class="form-label" for="Project Name">{m.options_general_project_description()}</label>
        <textarea class="form-control" bind:value={description}></textarea>
    </div>
    <div class="mb-3">
        <label class="form-label" for="Author">{m.options_general_created_by()}</label>
        <input class="form-control bg-light" type="text" disabled readonly value={projectState.username}>
    </div>
    <div class="mb-3">
        <label class="form-label" for="Created On Date">{m.options_general_created_on()}</label>
        <input class="form-control bg-light" type="text" disabled readonly value={createdOn}>
    </div>
    <div class="mb-3">
        <label class="form-label" for="Frame Rate">{m.options_general_frame_rate()} <i class="bi bi-info-circle" title={m.options_general_frame_rate_help()}></i></label>
        <input class="form-control bg-light" type="text" disabled readonly value={projectState.frameRate}>
    </div>
    <div class="mb-3">
        <label class="form-label" for="Aspect Ratio">{m.options_general_aspect_ratio()}</label>
        <select class="form-select" bind:value={aspectRatio}>
            <option value="16/9">16:9</option>
            <option value="4/3">4:3</option>
            <option value="1/1">1:1</option>
            <option value="9/16">9:16</option>
            <option value="21/9">21:9</option>
            <option value="143/100">1.43:1</option>
            <option value="185/100">1.85:1</option>
            <option value="235/100">2.35:1</option>
            <option value="239/100">2.39:1</option>
            <option value="276/100">2.76:1</option>
        </select>
    </div>
    <button id="saveGeneralSettingsButton" class="btn btn-primary float-end" type="button" onclick={saveChanges} aria-label={m.options_general_save_settings_label()}>{m.options_general_save_settings()}</button>
</form>
